<div class="Spa_Style_Note pt-2">{{ copyright || defaultCopyRight }}</div>
